import WebApp from "@twa-dev/sdk";

const NUM_OF_FIELDS = 5;

const regExp = new RegExp(String.raw`^[a-zA-Z0-9]{${NUM_OF_FIELDS}}$`);

export function isRefCodeValid(refCode: unknown): boolean {
  return (
    typeof refCode === "string" &&
    regExp.test(refCode) &&
    refCode.length === NUM_OF_FIELDS
  );
}

export function getRefCodeFromStartParam(): [string | null, boolean] {
  const startParam = WebApp.initDataUnsafe.start_param ?? "";
  const code = startParam.startsWith("ref_") ? startParam.substring(4) : null;
  const isValid = isRefCodeValid(code);

  return [code, isValid];
}
